import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { NavLink } from "react-router-dom"
import { motion } from 'framer-motion'
import { useWindowSize } from 'react-use'
import { isLoaded, isEmpty } from 'react-redux-firebase'
import gameActions from '../../store/actions/gameActions'
import LoggedInLinks from './LoggedInLinks'
import Button from '../Button'

const NavigationBar = () => {
    const [state, setState] = useState({
        isMobile: null,
        xlSidebarWidth: 270,
        mdSidebarWidth: 240,
        sidebarWidth: 240,
        isOpen: false,
        marginLeft: 0
    })

    const dispatch = useDispatch()
    const gameState = useSelector(state => state.game)
    const studygameState = useSelector(state => state.studyGame)
    const auth = useSelector(state => state.firebase.auth)
    const { width } = useWindowSize();

    useEffect(() => {
        const { mdSidebarWidth, xlSidebarWidth } = state;

        setState({
            ...state,
            isOpen: width > 768 && !gameState.narrative && !studygameState.isGameOn ? true : false,
            sidebarWidth: width < 768 ? width : width <= 1024 ? mdSidebarWidth : xlSidebarWidth,
            isMobile: width < 768
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [width, gameState.narrative, studygameState.isGameOn])

    const toggleSidebar = () => {
        setState({ ...state, isOpen: !state.isOpen })
    }

    const gameStateChapter = useSelector(state => state.game.chapter)
    const { isOpen, sidebarWidth } = state
    const x = isOpen ? 0 : -sidebarWidth

    const variants = {
        open: { opacity: 1, x: x, display: 'block' },
        closed: { opacity: 0, x: x, transitionEnd: { display: 'none' } },
    }

    return (
        <header
            style={{ display: gameStateChapter === 'cutscene-inicial' ? 'none' : 'flex' }}
            className='flex w-full justify-center items-center pb-8 md:pb-2'
        >
            {isLoaded(auth) && !isEmpty(auth) && width < 768 && !gameState.narrative && !studygameState.isGameOn &&
                <Button
                    className='p-2 rounded-full flex items-center justify-center'
                    onClick={() => toggleSidebar()}
                >
                    <img alt='Menu Hamburger' src={require(`../../assets/icons/32/hamburger-32.png`)} />
                </Button>
            }
            <motion.aside
                className="navbar fixed top-0 left-0 h-full"
                initial={variants.closed}
                animate={isOpen ? "open" : "closed"}
                variants={variants}
                style={{
                    width: sidebarWidth,
                }}
            >
                {width < 768 &&
                    <button className="navLink justify-end" onClick={() => toggleSidebar()}>
                        <img className='mr-2' alt='Fechar menu' title='Fechar menu' src={require('../../assets/icons/32/close-32.png')} />
                        <span>Fechar Menu</span>
                    </button>
                }
                {
                    !gameState.narrative && !studygameState.isGameOn ?
                        <LoggedInLinks />
                        : gameState.narrative &&
                        <NavLink
                            onClick={() => dispatch(gameActions.quitGame())}
                            className="navLink"
                            exact to='/dashboard'
                        >
                            
                            </NavLink>
                }
            </motion.aside>
            {isLoaded(auth) && !isEmpty(auth) && width < 768 &&
                <div style={{ flex: 'max-content' }} className='flex justify-center w-100'>
                    <img alt='Adventour Logo' src={require('../../assets/logo/nav-logo.png')} />
                </div>
            }
        </header>
    );
}

export default NavigationBar